module.exports = __webpack_public_path__ + "img/dining-2.00381fbc.png";